// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionTitle_wrapper__PICaV"};